var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentTokenDetails != null)?_c('div',[_c('TokenSummaryCard'),_c('OwnershipHistoryCard'),(_vm.isOwner)?_c('TransferCard'):_vm._e(),_c('DocumentListCard'),(_vm.isOwner)?_c('UploadDocumentCard'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }